<template>
  <InputComponent class="customfields-input" v-bind="$attrs" v-on="$listeners">
    <template v-if="Object.keys(popoverHelper).length" #after-label>
      <PopoverHelper :content="popoverHelper" />
    </template>
    <template v-if="copyToClipboard" #right>
      <ButtonComponent
        :label="$t('copy')"
        :success-label="$t('copied')"
        :icon="['fal', 'copy']"
        :promise="clipPromise"
        @click="copy"
      />
    </template>
    <template #default>
      <slot name="default"> </slot>
    </template>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import PopoverHelper from './Popover/Helper.vue'
import { CopyToClipboard } from '../utils'

export default {
  props: {
    popoverHelper: {
      type: Object,
      default: () => ({}),
    },
    copyToClipboard: Boolean,
    default: String,
  },
  data() {
    return {
      clipPromise: null,
    }
  },
  methods: {
    copy() {
      return (this.clipPromise = Promise.resolve(CopyToClipboard(this.$attrs.value)))
    },
  },

  created() {
    let hasDefaultProp = 'default' in this.$options.propsData
    if (hasDefaultProp && this.$attrs.value === undefined) {
      this.$emit('input', this.default)
    }
  },
  components: {
    InputComponent,
    PopoverHelper,
  },
}
</script>

<style lang="scss">
.customfields-input {
  .elder-input__label {
    display: block;
  }
}
</style>
